import { makeStyles } from "componentLibrary";
export var useStyles = makeStyles(function () {
  return {
    container: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%"
    },
    errorContainer: {
      display: "flex",
      alignItems: "center"
    },
    errorText: {
      marginRight: "16px"
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  };
});